// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"371e40fa","239":"b35b1b3f","453":"b3b29214","455":"93768cb3"}[chunkId] + ".chunk.js";
};